import { SET_PROMPTER_TEXT } from '../actionConstants';

export const setPrompterTextAction = (payload) => {
  return {
    type: SET_PROMPTER_TEXT,
    payload,
  };
};
